export const SUPPORT_EMAIL = "support@areaofpeople.com";
